import type { ContentData } from "@/api/content";
import { useLang } from "@/i18n/LanguageContext";

function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  return (parts[0][0] + (parts.length > 1 ? parts[parts.length - 1][0] : "")).toUpperCase();
}

export function ContactCardView({ content }: { content: ContentData }) {
  const { t } = useLang();
  const contacts = content.contacts ?? [];
  if (contacts.length === 0) return <p className="no-data-message">{t("Geen contacten.", "No contacts.")}</p>;
  return (
    <div className="contact-cards">
      {contacts.map((c, i) => (
        <div className="contact-card" key={i}>
          <div className="contact-avatar" aria-hidden="true">{initials(c.name)}</div>
          <div className="contact-body">
            <strong>{c.name}</strong>
            {c.role && <span className="contact-role">{c.role}</span>}
            {c.email && <a href={`mailto:${c.email}`}>{c.email}</a>}
            {c.phone && <a href={`tel:${c.phone.replace(/\s/g, "")}`}>{c.phone}</a>}
            {c.note && <p className="contact-note">{c.note}</p>}
          </div>
        </div>
      ))}
    </div>
  );
}
